import { render, staticRenderFns } from "./Procure.vue?vue&type=template&id=130b1740&scoped=true"
import script from "./Procure.vue?vue&type=script&lang=js"
export * from "./Procure.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130b1740",
  null
  
)

export default component.exports